export default "__VITE_ASSET__tsg3U1qj__";